import { Tools } from 'wax-prosemirror-core';
import { v4 as uuidv4 } from 'uuid';
import {
  getActiveStyle,
  fetchStyleXML,
  generateInTextCitation,
  getCachedStyleXML,
} from './CitationStyleService';
import { syncCitationOrder } from './syncCitationOrder';

class CitationTool extends Tools {
  title = 'Insert Citation';
  icon = 'blockquote';
  name = 'Citation';
  label = 'Citation';

  get run() {
    return (state, dispatch, view) => {
      const createCitation = this.container.get('CreateCitation');

      const docId = localStorage.getItem('documentSelected');
      const references = JSON.parse(localStorage.getItem(`${docId}_references`)) || [];

      if (references.length === 0) {
        alert('Please add references first using the Reference Manager');
        return false;
      }

      this.showCitationPicker(references, async (selectedRefs) => {
        if (selectedRefs && selectedRefs.length > 0) {
          // ── Build in-text citation string via CSL ──────────────────────────
          const activeStyle  = getActiveStyle();
          let styleXML = null;
          try {
            styleXML = await fetchStyleXML(activeStyle.id);
          } catch (err) {
            console.warn(`Failed to fetch CSL XML for style ${activeStyle.id}:`, err);
          }
          const citationText = generateInTextCitation(selectedRefs, styleXML);

          const citationId = uuidv4();

          // Persist the citation group so syncCitationOrder can look up refIds
          const docCitations = JSON.parse(localStorage.getItem(`${docId}_citations`)) || [];
          docCitations.push({
            id: citationId,
            referenceIds: selectedRefs.map((ref) => ref.id),
            text: citationText,
            timestamp: new Date().toISOString(),
          });
          localStorage.setItem(`${docId}_citations`, JSON.stringify(docCitations));

          createCitation(view, citationId, citationText);
          
          // Trigger automatic refresh
          setTimeout(() => {
            syncCitationOrder(view);
          }, 100);
        }
      });

      return true;
    };
  }

  showCitationPicker(references, callback) {
    window.dispatchEvent(
      new CustomEvent('showCitationPicker', { detail: { references, callback } })
    );
  }

  get active() {
    return () => false;
  }

  select = (state) => {
    const { schema } = state;
    return schema.marks.citation !== undefined;
  };
}

export default CitationTool;
